import * as React from "react"
import { Badge, Box, Grid } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


const info = [{
    color: 'info', 
    customColor: false,
    text: 'Matched by QA: when a user maps the product either from Product Review or from the Mapping App'
},{
    color: 'disabled.darker', 
    customColor: true,
    text: 'Validated: when a user reviews and approves the product'
},  {
    color: 'notice.main',
    customColor: true,
    text: 'Matched by IA: when the IA proposes a SKU, and it is accepted without QA intervention'
}, {
    color: 'success',
    customColor: false,
    text: 'Matched by Normalizer: when the normalizer finds the correct product (through EAN, model, etc.)'
}]


export default function AdminProductReviewFooterInfo() {

    return <Grid container sx={{ width: .7, mt: 2 }} alignItems="top">
        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconSeeker icon="info-circle" iconType="fontAwesome" size="medium" iconWeight="regular" sx={{ fontSize: '3rem', mr: 1, mt: -0.5 }}/>
        </Grid>
        <Grid item xs={10}>
            <Box sx={{ fontWeight: 'bold', fontSize: '1.5rem', pb: 1 }}>Matched by table info</Box>
            { info.map(( item, idx ) => <Box key={idx} sx={{ pl: 4 }}>
                {!item.customColor && <Badge color={item.color} badgeContent=" " /> }
                {item.customColor && <Badge sx={{ span: { backgroundColor: item.color } }} badgeContent=" " /> }
                <Box component="span" sx={{ ml: 2, verticalAlign: 'middle' }}>{item.text}</Box>
            </Box>) }
        </Grid>
    </Grid>
}